import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {AccessibilityModeButton} from '../accessibility-mode-button'
import {Legend} from '../plan/legend'
import {Summary} from '../summary'
import {TicketAction} from '../ticket/ticket-action'
import {TicketInfo} from '../ticket/ticket-info'
import s from './footer.scss'
import {FooterProps} from './index'

export const Footer = ({selectedPlace, withoutBreakdown, inDrawer, onCloseClick, onCheckoutClick}: FooterProps) => {
  const {isMobile} = useEnvironment()
  const {t} = useTranslation()
  const {getFormattedMoney, getTicketPriceText} = useCurrencyFormatter()

  return (
    <>
      {isMobile ? null : <AccessibilityModeButton />}
      <div className={classNames(s.footer, {[s.mobileFooter]: isMobile})} data-hook={DH.SEATINGS_FOOTER}>
        {isMobile ? (
          <Legend t={t} getTicketPriceText={getTicketPriceText} getFormattedMoney={getFormattedMoney} />
        ) : null}
        <div className={s.container}>
          {selectedPlace ? (
            <>
              <TicketInfo place={selectedPlace} selected={true} inDrawer={inDrawer} onCloseClick={onCloseClick} />
              <TicketAction place={selectedPlace} inDrawer={inDrawer} onClick={null} />
            </>
          ) : (
            <Summary withoutBreakdown={withoutBreakdown} onCheckoutClick={onCheckoutClick} />
          )}
        </div>
      </div>
    </>
  )
}
